export type AuthenticationProvider = "google" | "outlook"

export function parseAuthenticationProvider(value: string | null): AuthenticationProvider | null {
	if (value !== "google" && value !== "outlook") {
		return null
	}

	return value
}
